import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createVNode as _createVNode, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/vip/icon-close.png'
import _imports_1 from '@/assets/images/vip/poster.png'


const _withScopeId = n => (_pushScopeId("data-v-ce57c4ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "vip-dialog-dialog"
}
const _hoisted_2 = { class: "vip-header-container" }
const _hoisted_3 = { class: "vip-user-info" }
const _hoisted_4 = { class: "vip-head-img" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "vip-equity-box" }
const _hoisted_7 = { class: "equity-text" }
const _hoisted_8 = { class: "btns" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "main-container" }
const _hoisted_12 = {
  key: 0,
  class: "reload-box"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "reload-icon" }, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "页面加载失败了", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  })
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "right" }, null, -1))
const _hoisted_17 = {
  key: 1,
  class: "success-con"
}

import { computed, ref, Ref, onMounted, toRefs, watch, nextTick } from 'vue'
import dayjs from 'dayjs'
import {responseToCamelCase } from '@/utils/utils.js'
import { rePlayLoad, xesTrackVipPackageInfo } from './utils'
import { getVipDetail } from '@/api/vip'
import { useStore } from 'vuex'
import { useRouter }  from 'vue-router';

import {
    showPcpaperPopupvipbuyBlank,
    clickPcpaperPopupvipbuyTop,
    clickPcpaperPopupvipbuyBlank,
    clickPcpaperPopupvipbuyBuy,
    showPcpaperPopupvipbuySku,
    clickPcpaperPopupvipbuyAgreement,
    showPcpaperPopuppaysuccessBlank } from '@/trace/xesTrackVip.ts'
import { ElMessage } from 'element-plus'

import PayBtn from './PayBtn.vue'
import BuyVipSuccess from "@/components/buyVip/BuyVipSuccess.vue";

import defaultUserHead from '@/assets/images/vip/default-user-head.png'


export default /*#__PURE__*/_defineComponent({
  __name: 'VipDialog',
  setup(__props) {

/**
* @file VipDialog.vue
* @title 会员购买弹窗
* @author taomeili(taomeili@tal.com)
*
* @since 2023/5/13
*/
const router = useRouter()
const store = useStore()

const vipState = computed(() => store.state.vip)
const {showVipDialog, position, entrance} = toRefs(vipState.value)

const userInfo = computed(() => store.state.user.userInfo)

const paperVipInfo = computed(() => store.getters['user/paperVipInfo']);
const url = ref(window.location.origin + window.location.pathname);

const sectionOpacity = ref(1);
let currentIndex: Ref<number> = ref(0);
let currentItem: Ref<object|null> = ref(null);
const playLoad = ref({});
const showSuccessDialog = ref(false);
const successDialogInfo = ref({
    msgs: [],
    hasGifts: false,
});
let vipList = ref([]);
const loading = ref(false);
const reloadLoading = ref(false);
const showReloadBtn = ref(false);
let payBtnRef = ref(null);

const equityText = computed(() => {
    const defaultText = '海量名校试卷，会员免费下载';
    let text = defaultText;
    if (userInfo.value && paperVipInfo.value) {
        const useStatus = paperVipInfo.value.use_status;
        if (useStatus === 1) {
            const time = dayjs.unix(paperVipInfo.value.service_expired_time || 0).format('YYYY-MM-DD');
            text = `试卷宝会员 ${time} 到期`;
        } else if (useStatus === 2) {
            text = '会员已过期，续费畅享300万试卷免费下载';
        }
    }
    return text;
});
const xesTrackInfo = () => {
    return {
        is_login: userInfo.value ? '是' : '否',
        is_vip: paperVipInfo.value?.use_status === 1 ? '是' : '否',
        position: position.value,
        entrance: entrance.value,
    }
}

watch(showVipDialog, (newVal) => {
    if (newVal) {
        window.sessionStorage.setItem('isReserveShowVip', 'false');
        getVipDetailData();
        showPcpaperPopupvipbuyBlank({
            ...xesTrackInfo(),
        });
    }
});

const doDirectPay = async() => {
    // 简化购买会员弹窗会员支付逻辑：未登录点击去购买，去登录 登录后直接调支付
    const isDirectPay = window.sessionStorage.getItem('isDirectPay');
    const directPayInfo = window.sessionStorage.getItem('directPayInfo') || ''
    if (isDirectPay && directPayInfo) {
        window.sessionStorage.removeItem('isDirectPay');
        window.sessionStorage.removeItem('directPayInfo');
        const info = JSON.parse(directPayInfo);
        playLoad.value = info?.playLoad || {};
        currentIndex.value = info?.currentIndex * 1 || 0;
        // 调支付组件点击支付方法
        await nextTick();
        payBtnRef.value?.handlePay();
    }
}

watch(
    () => vipList.value,
    () => {
        nextTick(() => {
            doDirectPay();
        });
    },
    {flush: 'post'}
);
const noLogin = () => {
    window.sessionStorage.setItem('isReserveShowVip', 'true')
    store.dispatch('closeVipDialog')
    store.dispatch('openLogin')
}
const goToLogin = (type = '') => {
    if (type === 'name') {
        clickPcpaperPopupvipbuyTop({
            ...xesTrackInfo(),
        });
    }
    // 去登陆
    if (!userInfo.value) {
        const xesTrackVipInfo = JSON.stringify({
            position: position.value,
            entrance: entrance.value,
        });
        window.sessionStorage.setItem('isReserveShowVip', 'true')
        window.sessionStorage.setItem('xesTrackVipInfo', xesTrackVipInfo);
        store.dispatch('closeVipDialog')
        store.dispatch('openLogin')
        return;
    }
}
const handNickName = () => {
    clickPcpaperPopupvipbuyTop({
        ...xesTrackInfo(),
    });
}
const handleClose = () => {
    window.sessionStorage.setItem('isReserveShowVip', 'false');
    store.dispatch('reserveShowVip', false);
    store.dispatch('closeVipDialog');
    window.sessionStorage.removeItem('isDirectPay');
    window.sessionStorage.removeItem('directPayInfo');
}

const handleChooseCard = (index, item) => {
    currentIndex.value = index;
    currentItem.value = item;
    playLoad.value = rePlayLoad(item)
    clickPcpaperPopupvipbuyBlank({
        ...xesTrackVipPackageInfo(item),
        position: position.value,
        entrance: entrance.value,
    })
}

// sku曝光埋点
const xesTrackShowSku = () => {
    const info = vipList.value?.reduce((acc, cur) => {
        acc.skuIds.push(cur?.skuId);
        acc.skuNames.push(cur?.skuTitle);
        acc.promotionids.push(cur?.promotion?.map(e => e?.promotionId)?.join(','));
        return acc;
    }, {skuIds: [], skuNames: [], promotionids: []});
    const {skuIds = [], skuNames = [], promotionids = []} = info || {};
    showPcpaperPopupvipbuySku({
        sku_unionid: skuIds.join(),
        sku_name: skuNames.join(),
        promotion_id: promotionids.join(),
        position: position.value,
        entrance: entrance.value,
        card_type: '试卷宝',
		vip_version: '基础版/通用版',
		payscene: '普通支付',
    });
}
const handleReload = () => {
    if (reloadLoading.value) {
        return;
    }
    reloadLoading.value = true;
    getVipDetailData();
}
const getVipDetailData = () => {
    getVipDetail({
        is_whitelist: 0,
        type: 'goods',
        vip_type: 2,
    }).then(res => {
        if (res?.code) {
            return;
        }
        showReloadBtn.value = false;
        const groupList = res?.data?.goods?.group_list || [];
        const list = groupList.filter(item => item?.version === 1 && item?.type === 2).map(item => {
            const skuList = item?.sku_list || [];
            const skuListFilter = skuList.filter(skuItem => skuItem?.is_auto_renew === 0).slice(0, 3);
            return skuListFilter;
        }).flat();

        vipList.value = responseToCamelCase(list);
        const cItem = vipList.value[0];
        currentItem.value = cItem;
        // 埋点
        xesTrackShowSku()
        reloadLoading.value = false;

        // 重组下单数据
        playLoad.value = rePlayLoad(cItem)
        console.log(currentItem.value, '=========');
    }).catch(err => {
        if(err?.code === 100101) {
            ElMessage.closeAll();
            ElMessage.error(err?.message);
            noLogin();
            return;
        }
        showReloadBtn.value = true;
        reloadLoading.value = false;
        if (err?.includes('timeout')) {
            ElMessage.closeAll();
            ElMessage.error('请求超时，请稍后再试');
            return;
        }
        if (err === 'Network Error') {
            ElMessage.closeAll();
            ElMessage.error('网络不佳，请稍后再试');
            return;
        }
        console.log(err);
    });
}

// 支付成功
const paySuccess = (data) => {
    console.log(data, '---------权益')
    // 曝光埋点
    showPcpaperPopuppaysuccessBlank({
        position: position.value,
        entrance: entrance.value,
    });
    showSuccessDialog.value = true;
    const {hasOneYearCard, msgs} = data;

    successDialogInfo.value = {
        msgs,
        hasGifts: hasOneYearCard,
    };
    loading.value = false;
    // 关闭弹窗，重新请求用户权益接口
}
// 支付失败
const payFail = () => {
    loading.value = false;
    // ElMessage.error('支付失败');
}
const creatFail = () => {
    loading.value = false;
    // ElMessage.error('下单失败');
}
const handleBeforePay = () => {
    clickPcpaperPopupvipbuyBuy({
        ...xesTrackVipPackageInfo(currentItem.value),
        position: position.value,
        entrance: entrance.value,
    });
}
const handlePay = () => {
    loading.value = true;
}

const closeSuccesInfo = () => {
    showSuccessDialog.value = false;
}

const showNativePay = () => {
    loading.value = false;
    sectionOpacity.value = 0;
}
const paymentResultQuery = () => {
    // loading.value = true;
    const timer = setTimeout(() => {
        sectionOpacity.value = 1;
        clearTimeout(timer);
    }, 100);
};
const handleAgreement = () => {
    clickPcpaperPopupvipbuyAgreement();

    const routeUrl = router.resolve({
        path: '/agreement',
        query: {
            type: 1
        }
    })
    window.open(routeUrl.href, '_blank')
}
onMounted(() => {
    if (window.sessionStorage.getItem('isReserveShowVip') === 'true') {
        const xesTrackVipInfo = JSON.parse(window.sessionStorage.getItem('xesTrackVipInfo') || '{}') || {};
        store.dispatch('openVipDialog', xesTrackVipInfo);
    }
})


return (_ctx: any,_cache: any) => {
  const _directive_loading = _resolveDirective("loading")!

  return (_unref(showVipDialog))
    ? _withDirectives((_openBlock(), _createElementBlock("section", {
        key: 0,
        class: "vip-dialog-mask",
        "element-loading-background": "rgba(0, 0, 0, 0)",
        style: _normalizeStyle({opacity: sectionOpacity.value})
      }, [
        (!showSuccessDialog.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("img", {
                      src: userInfo.value?.avatar_url || _unref(defaultUserHead),
                      alt: "",
                      srcset: ""
                    }, null, 8, _hoisted_5)
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    (userInfo.value)
                      ? (_openBlock(), _createElementBlock("h3", {
                          key: 0,
                          class: "user-name",
                          onClick: handNickName
                        }, _toDisplayString(userInfo.value?.nickname), 1))
                      : (_openBlock(), _createElementBlock("h3", {
                          key: 1,
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (goToLogin('name'))),
                          class: "sign-login"
                        }, "注册/登录")),
                    _createElementVNode("p", _hoisted_7, _toDisplayString(equityText.value), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  (!userInfo.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "login-btn",
                        onClick: goToLogin
                      }, "立即登录"))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    class: "close-btn",
                    onClick: handleClose
                  }, _hoisted_10)
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                (showReloadBtn.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _hoisted_13,
                      _hoisted_14,
                      _createElementVNode("div", {
                        class: "reload-btn",
                        onClick: handleReload
                      }, "重新加载")
                    ]))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _hoisted_15,
                      _hoisted_16
                    ], 64))
              ])
            ]))
          : _createCommentVNode("", true),
        (showSuccessDialog.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _createVNode(BuyVipSuccess, {
                successDialogInfo: successDialogInfo.value,
                onCloseSuccesInfo: closeSuccesInfo,
                entrance: _unref(entrance),
                position: _unref(position)
              }, null, 8, ["successDialogInfo", "entrance", "position"])
            ]))
          : _createCommentVNode("", true)
      ], 4)), [
        [_directive_loading, loading.value]
      ])
    : _createCommentVNode("", true)
}
}

})